// Generated by scripts/character-assets.mts. Do not edit.
export const CHARACTER_ASSETS: Readonly<Record<string, { rig: "male" | "female"; fingerprint: string; hash: string; integrity: string }>> = {
  "/models/male/arms_rookie.glb": {
    "rig": "male",
    "fingerprint": "humanoid-v1-f6ceeb7e",
    "hash": "0454d381686beeb05988d52d4fac69dc3294ffe0c1f0f8dffb3cc5526a715940",
    "integrity": "sha256-BFTTgWhr7rBZiNUtT6xp3DKU/+DB8Pjf+zzFUmpxWUA="
  },
  "/models/male/back_drifter.glb": {
    "rig": "male",
    "fingerprint": "humanoid-v1-f6ceeb7e",
    "hash": "bc41d1ebf36407be6f9dcca3eeec98b8243f476f1f0f7886844552894111d0d4",
    "integrity": "sha256-vEHR6/NkB75vncyj7uyYuCQ/R28fD3iGhEVSiUER0NQ="
  },
  "/models/male/back_drifter_builds.glb": {
    "rig": "male",
    "fingerprint": "humanoid-v1-f6ceeb7e",
    "hash": "446f52d0f187da090126a6533daf8bb99cd2641cecbc42d8394b116d04a83446",
    "integrity": "sha256-RG9S0PGH2gkBJqZTPa+LuZzSZBzsvELYOUsRbQSoNEY="
  },
  "/models/male/body.glb": {
    "rig": "male",
    "fingerprint": "humanoid-v1-f6ceeb7e",
    "hash": "db2b5a858a443295a2d6ae095c544613be18eb456e2cb0d6fd75a139493a68b8",
    "integrity": "sha256-2ytahYpEMpWi1q4JXFRGE74Y60VuLLDW/XWhOUk6aLg="
  },
  "/models/male/body_base.glb": {
    "rig": "male",
    "fingerprint": "humanoid-v1-f6ceeb7e",
    "hash": "135b17dafc9c513b76cf5f5cd17b6ba150a9860f288a2131e69f039cc1139497",
    "integrity": "sha256-E1sX2vycUTt2z19c0XtroVCphg8oiiEx5p8DnMETlJc="
  },
  "/models/male/body_builds.glb": {
    "rig": "male",
    "fingerprint": "humanoid-v1-f6ceeb7e",
    "hash": "3aca847a716a6d282cf86661deaefa38b80a441617e257d2aa8e3b6ada2caa82",
    "integrity": "sha256-OsqEenFqbSgs+GZh3q76OLgKRBYX4lfSqo47atosqoI="
  },
  "/models/male/chest_drifter.glb": {
    "rig": "male",
    "fingerprint": "humanoid-v1-f6ceeb7e",
    "hash": "a6e4e83dc9f12f71e997606221a1f05b93dd33264107b58b7ec84d9c18ebc7ff",
    "integrity": "sha256-puToPcnxL3Hpl2BiIaHwW5PdMyZBB7WLfshNnBjrx/8="
  },
  "/models/male/chest_drifter_builds.glb": {
    "rig": "male",
    "fingerprint": "humanoid-v1-f6ceeb7e",
    "hash": "b50ee4133cf3fe2444222d4cd57ef106200e9fc04823476603ff7123558cc7ea",
    "integrity": "sha256-tQ7kEzzz/iREIi1M1X7xBiAOn8BII0dmA/9xI1WMx+o="
  },
  "/models/male/chest_rookie.glb": {
    "rig": "male",
    "fingerprint": "humanoid-v1-f6ceeb7e",
    "hash": "2abb7c4b59d03504662363e1bac27097f61854cd7da52291e1e18bcf38196ee4",
    "integrity": "sha256-Krt8S1nQNQRmI2PhusJwl/YYVM19pSKR4eGLzzgZbuQ="
  },
  "/models/male/feet_rookie.glb": {
    "rig": "male",
    "fingerprint": "humanoid-v1-f6ceeb7e",
    "hash": "257cba6a4a06f51a37679cbfb618b4929dec868b48bb31babe331a5e983bccb4",
    "integrity": "sha256-JXy6akoG9Ro3Z5y/thi0kp3shotIuzG6vjMaXpg7zLQ="
  },
  "/models/male/hair_braided-back.glb": {
    "rig": "male",
    "fingerprint": "humanoid-v1-f6ceeb7e",
    "hash": "85cf9e9024e5935642960e6dfdff003487497ccab5fc2af1ea1d68beb5d62c1c",
    "integrity": "sha256-hc+ekCTlk1ZClg5t/f8ANIdJfMq1/Crx6h1ovrXWLBw="
  },
  "/models/male/hair_buzz-cut.glb": {
    "rig": "male",
    "fingerprint": "humanoid-v1-f6ceeb7e",
    "hash": "077b530201e97e61c6fd2f271655ea47cc3a3fef12367cfcdc8a643fdeb23bd2",
    "integrity": "sha256-B3tTAgHpfmHG/S8nFlXqR8w6P+8SNnz83IpkP96yO9I="
  },
  "/models/male/hair_faux-hawk.glb": {
    "rig": "male",
    "fingerprint": "humanoid-v1-f6ceeb7e",
    "hash": "18c8370aa735533365935f915b449d5cb63dbe679e484d64c72364a8c4a3675b",
    "integrity": "sha256-GMg3Cqc1UzNlk1+RW0SdXLY9vmeeSE1kxyNkqMSjZ1s="
  },
  "/models/male/hair_medium-tousled.glb": {
    "rig": "male",
    "fingerprint": "humanoid-v1-f6ceeb7e",
    "hash": "d5cae4d6acd017567f4eb2db4d3cb73c7312a8137b2305bfe0f55701b203d0d4",
    "integrity": "sha256-1crk1qzQF1Z/TrLbTTy3PHMSqBN7IwW/4PVXAbID0NQ="
  },
  "/models/male/hair_messy-spikes.glb": {
    "rig": "male",
    "fingerprint": "humanoid-v1-f6ceeb7e",
    "hash": "a30d247e4257a54071b3ea034d70c3eb4c847070627c3b9a93e79f29c73fc4a2",
    "integrity": "sha256-ow0kfkJXpUBxs+oDTXDD60yEcHBifDuak+efKcc/xKI="
  },
  "/models/male/hair_short-crop.glb": {
    "rig": "male",
    "fingerprint": "humanoid-v1-f6ceeb7e",
    "hash": "fad5ae1406683999020f56f32f4e5c3a68248062627c5bfd028807fd5970d561",
    "integrity": "sha256-+tWuFAZoOZkCD1bzL05cOmgkgGJifFv9AogH/Vlw1WE="
  },
  "/models/male/hair_shoulder-straight.glb": {
    "rig": "male",
    "fingerprint": "humanoid-v1-f6ceeb7e",
    "hash": "b5abe6cff41fe4522fd495d0267260c97a6b653afa8616ae17de25d490f21367",
    "integrity": "sha256-tavmz/Qf5FIv1JXQJnJgyXprZTr6hhauF94l1JDyE2c="
  },
  "/models/male/hair_side-part.glb": {
    "rig": "male",
    "fingerprint": "humanoid-v1-f6ceeb7e",
    "hash": "38338a7366b6796f0cb494f503a03de2e863591e9f71e5b7b2f65293f716089d",
    "integrity": "sha256-ODOKc2a2eW8MtJT1A6A94uhjWR6fceW3svZSk/cWCJ0="
  },
  "/models/male/hair_spiky.glb": {
    "rig": "male",
    "fingerprint": "humanoid-v1-f6ceeb7e",
    "hash": "2b36c511dcd91efc0041b36e86097a00bd0a07acab9a6d105389f0caa289b17e",
    "integrity": "sha256-KzbFEdzZHvwAQbNuhgl6AL0KB6yrmm0QU4nwyqKJsX4="
  },
  "/models/male/hair_swept-back.glb": {
    "rig": "male",
    "fingerprint": "humanoid-v1-f6ceeb7e",
    "hash": "4df9fee9b91a06e402d0f34ff38e105797e0cd74c4e8d6c10cdb4443af996762",
    "integrity": "sha256-Tfn+6bkaBuQC0PNP844QV5fgzXTE6NbBDNtEQ6+ZZ2I="
  },
  "/models/male/hair_top-knot.glb": {
    "rig": "male",
    "fingerprint": "humanoid-v1-f6ceeb7e",
    "hash": "2d3d38c397896616169c92c4fe7df22c6d88f7632028ea4fe1338d5805608952",
    "integrity": "sha256-LT04w5eJZhYWnJLE/n3yLG2I92MgKOpP4TONWAVgiVI="
  },
  "/models/male/hair_undercut.glb": {
    "rig": "male",
    "fingerprint": "humanoid-v1-f6ceeb7e",
    "hash": "ff21e211d069dc1f1c81b5b806dd78e317f9aa6566371fd60b50979385753e9a",
    "integrity": "sha256-/yHiEdBp3B8cgbW4Bt144xf5qmVmNx/WC1CXk4V1Ppo="
  },
  "/models/male/hair_wavy-medium.glb": {
    "rig": "male",
    "fingerprint": "humanoid-v1-f6ceeb7e",
    "hash": "00e009781323c0d86e547bdf4671610cd9d5efbbec443198cecb9637d7c26e78",
    "integrity": "sha256-AOAJeBMjwNhuVHvfRnFhDNnV77vsRDGYzsuWN9fCbng="
  },
  "/models/male/hands_drifter.glb": {
    "rig": "male",
    "fingerprint": "humanoid-v1-f6ceeb7e",
    "hash": "818c6db5f104105d2b2f31d2bca78f71b7f1745f6d608f859707d5fd05135450",
    "integrity": "sha256-gYxttfEEEF0rLzHSvKePcbfxdF9tYI+FlwfV/QUTVFA="
  },
  "/models/male/hands_drifter_builds.glb": {
    "rig": "male",
    "fingerprint": "humanoid-v1-f6ceeb7e",
    "hash": "15989edb511a80939e98ebeb7bacd419fd240e93b3b42cb3f2ab3ddb89f9b343",
    "integrity": "sha256-FZie21EagJOemOvre6zUGf0kDpOztCyz8qs924n5s0M="
  },
  "/models/male/head_base.glb": {
    "rig": "male",
    "fingerprint": "humanoid-v1-f6ceeb7e",
    "hash": "556df02cf91c17b4d34d38b8907fb0829e0e202fda568a915e2a91740488289f",
    "integrity": "sha256-VW3wLPkcF7TTTTi4kH+wgp4OIC/aVoqRXiqRdASIKJ8="
  },
  "/models/male/head_broad.glb": {
    "rig": "male",
    "fingerprint": "humanoid-v1-f6ceeb7e",
    "hash": "264dad55b8a4a56e53e83a4957004365b5e0d8c2ed096efba441887acaa1206f",
    "integrity": "sha256-Jk2tVbikpW5T6DpJVwBDZbXg2MLtCW77pEGIesqhIG8="
  },
  "/models/male/head_drifter.glb": {
    "rig": "male",
    "fingerprint": "humanoid-v1-f6ceeb7e",
    "hash": "e267761e6631c8f40d9accceedb9f1b177fefbadd8cd330b7b0660e7ff89233b",
    "integrity": "sha256-4md2HmYxyPQNmszO7bnxsXf++63YzTMLewZg5/+JIzs="
  },
  "/models/male/head_drifter_builds.glb": {
    "rig": "male",
    "fingerprint": "humanoid-v1-f6ceeb7e",
    "hash": "22cd77c764d388b5e2c4f200f78c8f07f1b01a7d261bd9a06637344876506508",
    "integrity": "sha256-Is13x2TTiLXixPIA94yPB/GwGn0mG9mgZjc0SHZQZQg="
  },
  "/models/male/head_elegant.glb": {
    "rig": "male",
    "fingerprint": "humanoid-v1-f6ceeb7e",
    "hash": "eb5d4074241321954f2cf9d992ac0e8bdc655e0deb3b0479ad628c0fc1edd6fa",
    "integrity": "sha256-611AdCQTIZVPLPnZkqwOi9xlXg3rOwR5rWKMD8Ht1vo="
  },
  "/models/male/head_rugged.glb": {
    "rig": "male",
    "fingerprint": "humanoid-v1-f6ceeb7e",
    "hash": "f98fa5ada3dd75f0585b844bd0531b8b098ce57a120eb5b2ed6f9d8122a16c74",
    "integrity": "sha256-+Y+lraPddfBYW4RL0FMbiwmM5XoSDrWy7W+dgSKhbHQ="
  },
  "/models/male/head_sharp.glb": {
    "rig": "male",
    "fingerprint": "humanoid-v1-f6ceeb7e",
    "hash": "5fe4116b171cadf415068e3b27c7cfb1d37a35abc209ee7fb19901fcb8a422a5",
    "integrity": "sha256-X+QRaxccrfQVBo47J8fPsdN6NavCCe5/sZkB/LikIqU="
  },
  "/models/male/head_soft.glb": {
    "rig": "male",
    "fingerprint": "humanoid-v1-f6ceeb7e",
    "hash": "0e7a957728ea100c5a31c6547852e44a72c4f7c2391c8d2e75dae849a7f58305",
    "integrity": "sha256-DnqVdyjqEAxaMcZUeFLkSnLE98I5HI0uddroSaf1gwU="
  },
  "/models/male/pants_drifter.glb": {
    "rig": "male",
    "fingerprint": "humanoid-v1-f6ceeb7e",
    "hash": "db4f0af9957044ca5bc9389e7b67431a4f6a22fec1f5bf69cc9d40884410264b",
    "integrity": "sha256-208K+ZVwRMpbyTiee2dDGk9qIv7B9b9pzJ1AiEQQJks="
  },
  "/models/male/pants_drifter_builds.glb": {
    "rig": "male",
    "fingerprint": "humanoid-v1-f6ceeb7e",
    "hash": "259f4d10f1ab461968ef3b26a5809565e0c0969ec1068a7008d9ce4cb9ac44a7",
    "integrity": "sha256-JZ9NEPGrRhlo7zsmpYCVZeDAlp7BBopwCNnOTLmsRKc="
  },
  "/models/male/pants_rookie.glb": {
    "rig": "male",
    "fingerprint": "humanoid-v1-f6ceeb7e",
    "hash": "950a290db1cf610270cc5ee79685e0463060b84ad9e93909ef5c88113fb7bbb2",
    "integrity": "sha256-lQopDbHPYQJwzF7nloXgRjBguErZ6TkJ71yIET+3u7I="
  },
  "/models/male/shoe_drifter.glb": {
    "rig": "male",
    "fingerprint": "humanoid-v1-f6ceeb7e",
    "hash": "99eb96cf90312654eeef18d6d4fd80b08f06a088d5204a8f720e6faababc6934",
    "integrity": "sha256-meuWz5AxJlTu7xjW1P2AsI8GoIjVIEqPcg5vqrq8aTQ="
  },
  "/models/male/shoe_drifter_builds.glb": {
    "rig": "male",
    "fingerprint": "humanoid-v1-f6ceeb7e",
    "hash": "a71828ffb7db7c7d1dce54f4d9f419ab0db9202563e8b47ff803abcd104624b5",
    "integrity": "sha256-pxgo/7fbfH0dzlT02fQZqw25ICVj6LR/+AOrzRBGJLU="
  },
  "/models/male/shoulder_drifter.glb": {
    "rig": "male",
    "fingerprint": "humanoid-v1-f6ceeb7e",
    "hash": "3ee404c225d49a27dfb7e99e37317901bea002f618b834fe5e2f37764f87a9af",
    "integrity": "sha256-PuQEwiXUmifft+meNzF5Ab6gAvYYuDT+Xi83dk+Hqa8="
  },
  "/models/male/shoulder_drifter_builds.glb": {
    "rig": "male",
    "fingerprint": "humanoid-v1-f6ceeb7e",
    "hash": "16a6425fe41600c4af9967c83fca81078cfbf35333ca493eb88feb8501faca10",
    "integrity": "sha256-FqZCX+QWAMSvmWfIP8qBB4z781Mzykk+uI/rhQH6yhA="
  },
  "/models/male/waist_drifter.glb": {
    "rig": "male",
    "fingerprint": "humanoid-v1-f6ceeb7e",
    "hash": "e5a181d58b4272fc154e85871c0de2e4d789f46c5070520934b666fe08a10e35",
    "integrity": "sha256-5aGB1YtCcvwVToWHHA3i5NeJ9GxQcFIJNLZm/gihDjU="
  },
  "/models/male/waist_drifter_builds.glb": {
    "rig": "male",
    "fingerprint": "humanoid-v1-f6ceeb7e",
    "hash": "69a55b448c720209c9daa4ff83e13a033cd3a0139f5ab8afa3ff3c0c08b4fc1a",
    "integrity": "sha256-aaVbRIxyAgnJ2qT/g+E6AzzToBOfWrivo/88DAi0/Bo="
  },
  "/models/female/arms_rookie.glb": {
    "rig": "female",
    "fingerprint": "humanoid-v1-acbec8d9",
    "hash": "1dc7b3e697d270c775fdb0729f110536d416a0e0444089226bb592855f08c202",
    "integrity": "sha256-Hcez5pfScMd1/bBynxEFNtQWoOBEQIkia7WShV8IwgI="
  },
  "/models/female/body.glb": {
    "rig": "female",
    "fingerprint": "humanoid-v1-acbec8d9",
    "hash": "41bfcbd153451cfc5ccfa4422b6e590bae3550edda50ff0243334d2f0795bce7",
    "integrity": "sha256-Qb/L0VNFHPxcz6RCK25ZC641UO3aUP8CQzNNLweVvOc="
  },
  "/models/female/body_base.glb": {
    "rig": "female",
    "fingerprint": "humanoid-v1-acbec8d9",
    "hash": "ff3e3069ee077c1a3419228b817438bb796ee2eda4ebd61858839c4f45fb901e",
    "integrity": "sha256-/z4wae4HfBo0GSKLgXQ4u3lu4u2k69YYWIOcT0X7kB4="
  },
  "/models/female/body_builds.glb": {
    "rig": "female",
    "fingerprint": "humanoid-v1-acbec8d9",
    "hash": "5dbceba0e477065437a0876ba7b159795f921340837a68af7c41de38c4d5f784",
    "integrity": "sha256-XbzroOR3BlQ3oIdrp7FZeV+SE0CDemivfEHeOMTV94Q="
  },
  "/models/female/chest_rookie.glb": {
    "rig": "female",
    "fingerprint": "humanoid-v1-acbec8d9",
    "hash": "797f1475e863233ccc10ea7e7ca2f404a7db99371d645cb4179d3db3d4b3352b",
    "integrity": "sha256-eX8UdehjIzzMEOp+fKL0BKfbmTcdZFy0F509s9SzNSs="
  },
  "/models/female/feet_rookie.glb": {
    "rig": "female",
    "fingerprint": "humanoid-v1-acbec8d9",
    "hash": "778302daae2071b2c9fb2f3935e6fa94d029c0642f3c4ef1e2ee090447e79a7f",
    "integrity": "sha256-d4MC2q4gcbLJ+y85Neb6lNApwGQvPE7x4u4JBEfnmn8="
  },
  "/models/female/hair_braid.glb": {
    "rig": "female",
    "fingerprint": "humanoid-v1-acbec8d9",
    "hash": "09875f82d545ace0af7b6afe02fa006e60b9e45bfde1e859aabaf95344ba35aa",
    "integrity": "sha256-CYdfgtVFrOCve2r+AvoAbmC55Fv94ehZqrr5U0S6Nao="
  },
  "/models/female/hair_braided-crown.glb": {
    "rig": "female",
    "fingerprint": "humanoid-v1-acbec8d9",
    "hash": "5cac66485f447e0b7113d074b3b79bfafb73d21e860196d85cd39975b8665623",
    "integrity": "sha256-XKxmSF9EfgtxE9B0s7eb+vtz0h6GAZbYXNOZdbhmViM="
  },
  "/models/female/hair_curly-puff.glb": {
    "rig": "female",
    "fingerprint": "humanoid-v1-acbec8d9",
    "hash": "455f69a3da07aff6fb890f277b6f396b4370731d1002fb5fd835bf0903c8bbe9",
    "integrity": "sha256-RV9po9oHr/b7iQ8ne285a0Nwcx0QAvtf2DW/CQPIu+k="
  },
  "/models/female/hair_high-ponytail.glb": {
    "rig": "female",
    "fingerprint": "humanoid-v1-acbec8d9",
    "hash": "192470a7641fce478f15467b381f4af8703cb5b6cb24fbe5dedaadd3afa147f4",
    "integrity": "sha256-GSRwp2QfzkePFUZ7OB9K+HA8tbbLJPvl3tqt06+hR/Q="
  },
  "/models/female/hair_layered-medium.glb": {
    "rig": "female",
    "fingerprint": "humanoid-v1-acbec8d9",
    "hash": "01796acef9bac805c7d5112dfe7d933fc641667181e1e3d9ccc831ef6269a8c2",
    "integrity": "sha256-AXlqzvm6yAXH1REt/n2TP8ZBZnGB4ePZzMgx72JpqMI="
  },
  "/models/female/hair_long-straight.glb": {
    "rig": "female",
    "fingerprint": "humanoid-v1-acbec8d9",
    "hash": "73778660a25800f96890d5db51247c4bb0ec7fe12beaebf50a915902ea3e0f48",
    "integrity": "sha256-c3eGYKJYAPlokNXbUSR8S7Dsf+Er6uv1CpFZAuo+D0g="
  },
  "/models/female/hair_long.glb": {
    "rig": "female",
    "fingerprint": "humanoid-v1-acbec8d9",
    "hash": "28d519a1c687fa699c7561fd9aefefed4991b3ec3ee61418477a11fdda66d6b6",
    "integrity": "sha256-KNUZocaH+mmcdWH9mu/v7UmRs+w+5hQYR3oR/dpm1rY="
  },
  "/models/female/hair_low-bun.glb": {
    "rig": "female",
    "fingerprint": "humanoid-v1-acbec8d9",
    "hash": "f9de6787b06b0ab929a1dd28a74f242a1907aacfd91452a5e0dde316b1f9087f",
    "integrity": "sha256-+d5nh7BrCrkpod0op08kKhkHqs/ZFFKl4N3jFrH5CH8="
  },
  "/models/female/hair_pixie.glb": {
    "rig": "female",
    "fingerprint": "humanoid-v1-acbec8d9",
    "hash": "d58ea25313791a38d91dbc68413371418cd8466243ace2ab2a2a451661a18f15",
    "integrity": "sha256-1Y6iUxN5GjjZHbxoQTNxQYzYRmJDrOKrKipFFmGhjxU="
  },
  "/models/female/hair_short-bob.glb": {
    "rig": "female",
    "fingerprint": "humanoid-v1-acbec8d9",
    "hash": "a24dc9cb49a0bf56fde9540f13d1abfdf34462f71e7367b3d94ba0e231241fb2",
    "integrity": "sha256-ok3Jy0mgv1b96VQPE9Gr/fNEYvcec2ez2Uug4jEkH7I="
  },
  "/models/female/hair_side-shave.glb": {
    "rig": "female",
    "fingerprint": "humanoid-v1-acbec8d9",
    "hash": "2ae01624a4184fc32a4b38e4a336a942eea3444a1a61d5b720a03b36bf217eb8",
    "integrity": "sha256-KuAWJKQYT8MqSzjkozapQu6jREoaYdW3IKA7Nr8hfrg="
  },
  "/models/female/hair_top-knot.glb": {
    "rig": "female",
    "fingerprint": "humanoid-v1-acbec8d9",
    "hash": "2168e27a11f3a9acb5463a36d371c0ca4b5989275c3f775891cea1f498b5c065",
    "integrity": "sha256-IWjiehHzqay1Rjo203HAyktZiSdcP3dYkc6h9Ji1wGU="
  },
  "/models/female/hair_twin-braids.glb": {
    "rig": "female",
    "fingerprint": "humanoid-v1-acbec8d9",
    "hash": "f1860e7357d34e672db6048720439123de3a66e178ac39782aa592759de2c98f",
    "integrity": "sha256-8YYOc1fTTmcttgSHIEORI946ZuF4rDl4KqWSdZ3iyY8="
  },
  "/models/female/hair_wavy-shoulder.glb": {
    "rig": "female",
    "fingerprint": "humanoid-v1-acbec8d9",
    "hash": "05b74f7bbd0fb1135c8389695be9d35f4846dafdb48b4c9e3a21546617d7b242",
    "integrity": "sha256-BbdPe70PsRNcg4lpW+nTX0hG2v20i0yeOiFUZhfXskI="
  },
  "/models/female/head_base.glb": {
    "rig": "female",
    "fingerprint": "humanoid-v1-acbec8d9",
    "hash": "4269ecf117e73470c29c0114d09402822d4f76d73e3d0767184ebcad7b1594a8",
    "integrity": "sha256-Qmns8RfnNHDCnAEU0JQCgi1Pdtc+PQdnGE68rXsVlKg="
  },
  "/models/female/head_broad.glb": {
    "rig": "female",
    "fingerprint": "humanoid-v1-acbec8d9",
    "hash": "7953319c605bde4b0d4415b1dfb1267a20eb6506bdae622ae0dbc50421aefeba",
    "integrity": "sha256-eVMxnGBb3ksNRBWx37EmeiDrZQa9rmIq4NvFBCGu/ro="
  },
  "/models/female/head_elegant.glb": {
    "rig": "female",
    "fingerprint": "humanoid-v1-acbec8d9",
    "hash": "22a8fce1d41260c8389e3ad84ac91c96168c9c774728c85b4d46ead4af11de58",
    "integrity": "sha256-Iqj84dQSYMg4njrYSskclhaMnHdHKMhbTUbq1K8R3lg="
  },
  "/models/female/head_original.glb": {
    "rig": "female",
    "fingerprint": "humanoid-v1-acbec8d9",
    "hash": "d34e2b9bc55c470c1b9acb21a40cc70fe18ff068701c7888b8c9a53088f36bfc",
    "integrity": "sha256-004rm8VcRwwbmsshpAzHD+GP8GhwHHiIuMmlMIjza/w="
  },
  "/models/female/head_rugged.glb": {
    "rig": "female",
    "fingerprint": "humanoid-v1-acbec8d9",
    "hash": "07f95f26f80e1a9e662513a6ae6806cd4d5fb897b5ec49063d1d71eced5a07fa",
    "integrity": "sha256-B/lfJvgOGp5mJROmrmgGzU1fuJe17EkGPR1x7O1aB/o="
  },
  "/models/female/head_sharp.glb": {
    "rig": "female",
    "fingerprint": "humanoid-v1-acbec8d9",
    "hash": "d983e42a3380d373bea947f646391ae20a34991803c48f2ef438a29cff7ce060",
    "integrity": "sha256-2YPkKjOA03O+qUf2Rjka4go0mRgDxI8u9DiinP984GA="
  },
  "/models/female/head_soft.glb": {
    "rig": "female",
    "fingerprint": "humanoid-v1-acbec8d9",
    "hash": "07a796433a699c483acbc2458f0a537b4a9e2a81ddda785dfc0ea8bfce68bcb4",
    "integrity": "sha256-B6eWQzppnEg6y8JFjwpTe0qeKoHd2nhd/A6ov85ovLQ="
  },
  "/models/female/pants_rookie.glb": {
    "rig": "female",
    "fingerprint": "humanoid-v1-acbec8d9",
    "hash": "2aa75fbda9e00a885e588b8f95229234f94da6484cb895c0466149e981efd78c",
    "integrity": "sha256-KqdfvangCoheWIuPlSKSNPlNpkhMuJXARmFJ6YHv14w="
  }
};
